/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'
import * as ModerationDefs from '../../../com/atproto/moderation/defs.defs.js'

const $nsid = 'app.bsky.labeler.defs'

export { $nsid }

type LabelerView = {
  $type?: 'app.bsky.labeler.defs#labelerView'
  uri: l.AtUriString
  cid: l.CidString
  creator: ActorDefs.ProfileView
  likeCount?: number
  viewer?: LabelerViewerState
  indexedAt: l.DatetimeString
  labels?: LabelDefs.Label[]
}

export type { LabelerView }

const labelerView = l.typedObject<LabelerView>(
  $nsid,
  'labelerView',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    creator: l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),
    likeCount: l.optional(l.integer({ minimum: 0 })),
    viewer: l.optional(
      l.ref<LabelerViewerState>((() => labelerViewerState) as any),
    ),
    indexedAt: l.string({ format: 'datetime' }),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
  }),
)

export { labelerView }

type LabelerViewDetailed = {
  $type?: 'app.bsky.labeler.defs#labelerViewDetailed'
  uri: l.AtUriString
  cid: l.CidString
  creator: ActorDefs.ProfileView
  policies: LabelerPolicies
  likeCount?: number
  viewer?: LabelerViewerState
  indexedAt: l.DatetimeString
  labels?: LabelDefs.Label[]

  /**
   * The set of report reason 'codes' which are in-scope for this service to review and action. These usually align to policy categories. If not defined (distinct from empty array), all reason types are allowed.
   */
  reasonTypes?: ModerationDefs.ReasonType[]

  /**
   * The set of subject types (account, record, etc) this service accepts reports on.
   */
  subjectTypes?: ModerationDefs.SubjectType[]

  /**
   * Set of record types (collection NSIDs) which can be reported to this service. If not defined (distinct from empty array), default is any record type.
   */
  subjectCollections?: l.NsidString[]
}

export type { LabelerViewDetailed }

const labelerViewDetailed = l.typedObject<LabelerViewDetailed>(
  $nsid,
  'labelerViewDetailed',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    creator: l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),
    policies: l.ref<LabelerPolicies>((() => labelerPolicies) as any),
    likeCount: l.optional(l.integer({ minimum: 0 })),
    viewer: l.optional(
      l.ref<LabelerViewerState>((() => labelerViewerState) as any),
    ),
    indexedAt: l.string({ format: 'datetime' }),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    reasonTypes: l.optional(
      l.array(
        l.ref<ModerationDefs.ReasonType>(
          (() => ModerationDefs.reasonType) as any,
        ),
      ),
    ),
    subjectTypes: l.optional(
      l.array(
        l.ref<ModerationDefs.SubjectType>(
          (() => ModerationDefs.subjectType) as any,
        ),
      ),
    ),
    subjectCollections: l.optional(l.array(l.string({ format: 'nsid' }))),
  }),
)

export { labelerViewDetailed }

type LabelerViewerState = {
  $type?: 'app.bsky.labeler.defs#labelerViewerState'
  like?: l.AtUriString
}

export type { LabelerViewerState }

const labelerViewerState = l.typedObject<LabelerViewerState>(
  $nsid,
  'labelerViewerState',
  l.object({ like: l.optional(l.string({ format: 'at-uri' })) }),
)

export { labelerViewerState }

type LabelerPolicies = {
  $type?: 'app.bsky.labeler.defs#labelerPolicies'

  /**
   * The label values which this labeler publishes. May include global or custom labels.
   */
  labelValues: LabelDefs.LabelValue[]

  /**
   * Label values created by this labeler and scoped exclusively to it. Labels defined here will override global label definitions for this labeler.
   */
  labelValueDefinitions?: LabelDefs.LabelValueDefinition[]
}

export type { LabelerPolicies }

const labelerPolicies = l.typedObject<LabelerPolicies>(
  $nsid,
  'labelerPolicies',
  l.object({
    labelValues: l.array(
      l.ref<LabelDefs.LabelValue>((() => LabelDefs.labelValue) as any),
    ),
    labelValueDefinitions: l.optional(
      l.array(
        l.ref<LabelDefs.LabelValueDefinition>(
          (() => LabelDefs.labelValueDefinition) as any,
        ),
      ),
    ),
  }),
)

export { labelerPolicies }
